import { Box, Typography } from "@mui/material";
import React from "react";

const BoxFrequenceAccess = ({ data }) => {
  return (
    <Box direction="horizontal" gap={2}>
      <Typography sx={{ textAlign: "end" }} variant="h3">
        <b>{data.number_access}</b>
      </Typography>
    </Box>
  );
};

export default BoxFrequenceAccess;
